import { useQuery } from 'react-query';

import { getCardInit as queryFn } from 'api/endPoints/getCardInit';
import { QueryKeys } from 'api/queryKeys';

import {
    IActivityCode,
    IActivityType,
    IAssignee,
    ICardImportant,
    ICardType,
    ICardUrgent,
    ICategory,
    IProjectContractVersions,
    IStatus,
    IStoredFilters,
    ITagList,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

export const useQueryGetBoardInitLite = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getBoardInitLite', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.projectId),
    });
};

export interface QueryParams {
    projectId?: number;
}

export interface QueryResponse {
    activityCode: IActivityCode | null;
    assignee: IAssignee[];
    cardActivityType: IActivityType[];
    cardImportant: ICardImportant[];
    cardType: ICardType[];
    cardUrgent: ICardUrgent[];
    category: ICategory[];
    projectContractVersions: IProjectContractVersions[];
    status: IStatus[];
    storedFilters: IStoredFilters[];
    tags: ITagList[];
}
